import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectToasts } from 'src/old/actions/toasts/toastsSelectors';
import { removeToast } from 'src/old/actions';
import Toast from './Toast';

const Toasts = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(selectToasts);

  return toasts?.map(toast => {
    const { id } = toast || {};

    return (
      <Fragment key={id}>
        <Toast {...toast} id={id} onDismissClick={() => dispatch(removeToast(id))} />
      </Fragment>
    );
  });
};

export default Toasts;
